/* Open desktop nav dropdowns on hover (CBV-style) */
(function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
    var item = details.closest('li') || details;
    var closeTimer;
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });
    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });
  });
})();
